/** KAN-746: подписи интерфейса по режиму текущего кабинета (lib/modeLabels). */
import { useOrgMode } from '@/hooks/useOrgMode';
import { modeLabels, type ModeLabels } from '@/lib/modeLabels';

export function useModeLabels(): ModeLabels {
  return modeLabels(useOrgMode());
}
